import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import MenuBotones from "../../MenuBotones";

function BotonesNominas() {
  const { user } = useContext(AuthContext);

  const SECCIONES = [
    { section: "Personal", items: [
      { label: "Empleados", icon: "fas fa-address-card", color: "#14b8a6", href: "/Empleados", desc: "Padron de empleados", enabled: !!user.menu_empleados },
      { label: "Puestos", icon: "fas fa-address-book", color: "#64748b", href: "/Puestos", desc: "Catalogo de puestos", enabled: !!user.menu_puestos },
    ]},
    // { section: "Nómina", items: [
    //   { label: "Nominas", icon: "fas fa-briefcase", color: "#10b981", href: "/Nominas", desc: "Calculo de nomina", enabled: !!user.nominas_listado },
    //   { label: "Faltas", icon: "fas fa-calendar-times", color: "#f59e0b", href: "/FaltasColaboradores", desc: "Faltas e incidencias", enabled: !!user.faltas_empleados },
    // ]},
  ];

  return (
    <MenuBotones
      titulo="Empleados"
      descripcion="Personal, puestos y nomina"
      icono="fas fa-address-card"
      color="#14b8a6"
      secciones={SECCIONES}
    />
  );
}

export default BotonesNominas;
